import { fromLonLat } from 'ol/proj';

export const GET_MAP = Symbol();
export const REFIT = Symbol();

export const LOCATION_GERMANY = fromLonLat([10.4515, 51.1657]);
